import { DogeUniAdapter } from './DogeUni';
import { MyDogeAdapter } from './MyDoge';

export const adapters = [new MyDogeAdapter(), new DogeUniAdapter()];
